export default {
  email: null,
  telephone: null,
  celphone: null,
  position: null,
  name: null,
  comment:null, 
}